export default __webpack_public_path__ + "static/media/logo_blanco.145b9f07.png";